import { useState, useEffect } from "react";
import api from "@/lib/api";

export default function usePlan() {
    const [plan, setPlan] = useState(null);
    useEffect(() => {
        api.get("/api/billing/current-plan")
            .then((r) => setPlan(r.data?.plan ?? "free"))
            .catch(() => setPlan("free"));
    }, []);
    return plan;
}
